import { render } from "./widget-base.vue?vue&type=template&id=ba789a14&ts=true"
import script from "./widget-base.ts?vue&type=script&lang=ts"
export * from "./widget-base.ts?vue&type=script&lang=ts"

import "./widget-base.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__